// store/index.ts
import { createStore, combineReducers } from 'redux';
import authReducer from '../reducers/auth_reducer';
import hallsReducer from '../reducers/hall_reducer';
import eventsReducer from '../reducers/event_reducer';
import salesManagementReducer from '../reducers/sales_management_reducer';

const rootReducer = combineReducers({
    authReducer: authReducer,
    hallsReducer: hallsReducer,
    eventsReducer: eventsReducer,
    salesManagementReducer: salesManagementReducer
});

export type RootState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer);

export default store;
